"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SummaryTable = _interopRequireDefault(require("./SummaryTable"));
var _outcomesQuery = _interopRequireDefault(require("./outcomesQuery.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LogTable = function LogTable(props) {
  var totalSessions = 5;
  var _props$settings = props.settings,
    title = _props$settings.title,
    description = _props$settings.description,
    show = _props$settings.show;
  // console.log(props.filters);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '1.5em'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '0.5em'
    }
  }, description), /*#__PURE__*/_react["default"].createElement(_SummaryTable["default"], {
    totalSessions: totalSessions,
    query: props.query ? props.query : _outcomesQuery["default"],
    filters: props.filters
  })));
};
LogTable.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object
};
LogTable.defaultProps = {
  filters: {}
};
var _default = exports["default"] = LogTable;